import { FC, MouseEventHandler, ReactElement, useState } from 'react';
import isEmpty from 'lodash/isEmpty';

import ProductSalesStateDescriptionPopup from '../product/ProductSalesStateDescriptionPopup';
import { InvoiceOut } from '../../store/api';
import { useTranslation } from 'react-i18next';
import { mapSalesStatus } from './translationMappers/salesStatusMapper';

interface Props {
    status?: string;
    amount?: number;
    invoice?: InvoiceOut;
    onDownloadInvoice: (invoice: InvoiceOut) => void;
    productAmount?: number;
    salesStatus: any;
    displayBadge: boolean;
}

const OrderStatusButton: FC<Props> = ({
    status = '',
    invoice = null,
    onDownloadInvoice,
    amount,
    displayBadge = false,
    salesStatus
}) => {
    const [showPreOrderDescription, setShowPreOrderDescription] = useState(false);

    function buildStatusInvoice() {
        return `${status} - ${invoice?.invoiceType} ${invoice?.invoiceNumber}`;
    }

    let mouseEnterOpenDescription: MouseEventHandler<HTMLDivElement> | undefined;
    let mouseLeaveCloseDescription: MouseEventHandler<HTMLDivElement> | undefined;
    let salesStateDescriptionContainer: ReactElement<any, any> | undefined = undefined;
    const productAmount = amount;
    const { t } = useTranslation();
    const statusButton = invoice ? (
        <a onClick={() => onDownloadInvoice(invoice)} className="status-button">
            {buildStatusInvoice()}
        </a>
    ) : (
        <label className="status-text">{status}</label>
    );
    const badge = displayBadge ? <label className="product-amount-badge">{productAmount}</label> : null;
    const salesStatusMappedKey = mapSalesStatus(salesStatus);
    const description = t(`components.salesStatus.${salesStatusMappedKey}.description`);
    if (salesStatus !== 'COMING_SOON') {
        if (!isEmpty(salesStatusMappedKey)) {
            mouseEnterOpenDescription = () => {
                setShowPreOrderDescription(true);
            };

            mouseLeaveCloseDescription = () => {
                setShowPreOrderDescription(false);
            };

            if (showPreOrderDescription) {
                salesStateDescriptionContainer = <ProductSalesStateDescriptionPopup description={description} />;
            }
        }
    }

    return (
        <div
            className="order-status-button"
            onMouseEnter={mouseEnterOpenDescription}
            onMouseLeave={mouseLeaveCloseDescription}
        >
            {statusButton}
            {badge}
            {salesStateDescriptionContainer}
        </div>
    );
};

export default OrderStatusButton;
